



















































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { AxiosVue } from '@/AxiosVue';
import { fetchMantenedorTramos } from './fetchMantenedorTramos';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import DownloadIcon from './DownloadIcon.vue';
import ModalCrearTramo from '@/pantallas/Conecta/MantenedorTramos/ModalCrearTramo.vue';
@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    ModalCrearTramo,
  },
})
export default class MantanedorTramos extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.MantenedorTramos;
  model_filtro_tramo: any = null;
  model_filtro_tipo: any = null;
  tramos: any = [];
  filtro_tipo: any[] = [];
  gridApi: GridApi = null;
  columnApi: any = null;
  data: any = {};
  tramos_Seleccionada: any = null;
  tramosModalState: boolean = false;
  esEdicion: boolean = false;
  accion_modal: String = '';
  isEdit: boolean = false;
  filtrobusquedaTramos: string = '';

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.accionVerDetalle, this.accionEditar];
  actions() {
    actionsEvent.onEditar(this.handlerbuttonmodalEditar);
  }
  constructor() {
    super();
    this.actions();
  }
  handlerbuttonmodalEditar(params: ICellRendererParams) {
    this.data = params.data;
    this.tramos_Seleccionada = params.data['id'];
    this.tramosModalState = true;
    this.isEdit = true;
    this.accion_modal = 'EDITAR';
  }

  async cleanfilters() {
    this.model_filtro_tramo = null;
    this.model_filtro_tipo = null;
    this.handleGridReady();
  }
  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Tramo',
        field: 'nombre_tramo',
        width: 190,
        filter: true,
      },
      {
        headerName: 'Tipo de Tramo',
        field: 'tipo_tramo',
        width: 150,
        filter: true,
      },
      {
        headerName: 'Usuario Creador',
        field: 'usuario_creador',
        width: 180,
        filter: true,
      },
      {
        headerName: 'Fecha de Creación',
        field: 'fecha_creacion',
        width: 170,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD'),
      },
      {
        headerName: 'Usuario Ultima Edición',
        field: 'usuario_ultima_edicion',
        width: 190,
        filter: true,
      },
      {
        headerName: 'Fecha de Edición',
        field: 'fecha_edicion',
        width: 190,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD'),
      },
      {
        headerName: 'Activo',
        field: 'activo',
        width: 160,
        filter: true,
      },
    ],
    rowSelection: 'multiple',
    pagination: true,
    paginationPageSize: 6, //Solución Paginación
    cacheBlockSize: 6, //Solución Paginación //Ordenamiento + Seleccion
    paginationAutoPageSize: false,
    rowModelType: 'normal',
    columnTypes: {
      fecha: {
        sortable: true,
        resizable: true,
        filter: true,
      },
    },
    suppressCsvExport: true,
    suppressExcelExport: true,
    onGridReady: this.onGridReady,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
  };
  async handleGridReady() {
    await this.getFilters();
    this.tramos = await this.get_grid_data_tramos();
    this.gridApi.setRowData(this.tramos);
    this.gridApi.setDomLayout('autoHeight');
    /*     this.copy_scroll();*/
  }

  async getFilters() {
    try {
      this.loadingService.showLoading(undefined, 'getFilters');
      const result = await fetchMantenedorTramos(
        {},
        'conecta_mantenedor_tramos/get_filters'
      );
      this.filtro_tipo = result.data.TIPO.LISTA;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 300 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 300 }
      );
    } finally {
      this.loadingService.hideLoading('getFilters');
    }
  }

  async applyfilters() {
    let body: { [key: string]: string } = {
      filtro_tramo: this.model_filtro_tramo,
      filtro_tipo: this.model_filtro_tipo,
    };
    this.tramos = await this.get_grid_data_tramos(body);
    this.gridApi.setRowData(this.tramos);
    this.gridApi.setDomLayout('autoHeight');
    /*     this.copy_scroll();
     */
  }
  async get_grid_data_tramos(filter_data: any = null) {
    //this.gridApi.rowModel.rowsToDisplay = this.rowcount;
    let self = this;
    if (filter_data == null) {
      filter_data = { '': '' };
    }
    this.loadingService.showLoading(undefined, 'get_grid_data_tramos');
    return fetchMantenedorTramos(filter_data, 'conecta_mantenedor_tramos')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data.LISTA[0].nombre_tramo != undefined) {
            return data.data.data.LISTA;
          } else {
            return null;
          }
        }
      })
      .catch((error: any) => null)
      .finally(() => this.loadingService.hideLoading('get_grid_data_tramos'));
  }
  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.handleGridReady();
  }
  async modalverDetalleCallback(event: any) {
    this.tramosModalState = event;
    this.tramos = await this.get_grid_data_tramos();
    this.gridApi.setRowData(this.tramos);
    /*         this.copy_scroll();
     */
  }
  handleCierreModalAsignacion() {
    actionsEvent.removeListeners();
    this.tramosModalState = false;
    this.data = {};
    this.tramos_Seleccionada = {};
    this.actions();
    this.handleGridReady();
  }
  handlerbuttonmodal() {
    this.tramos_Seleccionada = null;
    this.tramosModalState = true;
    this.accion_modal = 'CREAR';
    this.isEdit = false;
  }

  searchDataActividad() {
    this.gridApi.setQuickFilter(this.filtrobusquedaTramos);
    this.gridApi.setDomLayout('autoHeight');
  }
}
